import {useSearchParams, useNavigate} from "react-router-dom";
import {useEffect} from "react";
import {VerifyEmailActionHandler} from "./VerifyEmailActionHandler.tsx";
import { ResetPasswordActionHandler } from "./ResetPasswordActionHandler.tsx";

export default function FirebaseActionHandler() {
    const [searchParams] = useSearchParams();

    const mode = searchParams.get('mode') || '';
    const actionCode = searchParams.get('oobCode') || '';
    const continueUrl = searchParams.get('continueUrl') || '';


    if (mode !== 'verifyEmail' && mode !== 'resetPassword' && mode !== 'recoverEmail') {
        return null; 
    }

    if (mode === 'resetPassword') {
        return <ResetPasswordActionHandler actionCode={actionCode} continueUrl={continueUrl} />; 
    }
    if (mode === 'verifyEmail') {
        return <VerifyEmailActionHandler actionCode={actionCode} continueUrl={continueUrl}  />;
    }

    if (mode === 'recoverEmail') {
        return (
            <div className='w-96 mx-auto mt-48'>
                <h1 className="mt-8 text-3xl font-bold leading-9 tracking-tight text-gray-900">Recover email</h1>
                <p className="mt-2 text-sm text-gray-600">This feature is not yet implemented.</p>
            </div>
        );
    }

    return null;
}
